import { useTranslation } from "react-i18next";

export type Language = "en" | "nb";
export const language: Record<string, Language> = {
    english: "en",
    norwegian: "nb",
};

export function useSetLanguage() {
    const { i18n } = useTranslation();
    const currentLanguage: Language = i18n.language?.startsWith("en") ? "en" : "nb";

    const changeLanguage = (lng: Language) => {
        i18n.changeLanguage(lng).then(() => {
            localStorage.setItem("i18nLng", lng);
        });
    };

    const handleLanguageChange = (lng: Language) => {
        changeLanguage(lng);
    };

    return { currentLanguage, handleLanguageChange };
}
